import { endOfMonth, format, getDate, getDay, getMonth, getYear, set, startOfMonth } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'

import { ISection } from 'store/modules/goal/types'
import { timeConfiguration } from 'utils/timeConfiguration'

const MAX_MONTHS_AHEAD_FOR_GOALS = 6

export const derivePeriodTypeFromSections = (
  sections: Array<{ start: string | Date; end: string | Date }> | undefined
): 'single' | 'multiple' | null => {
  if (!sections || sections.length === 0) return null
  return sections.length > 1 ? 'multiple' : 'single'
}

export const getSundaysInMonth = (monthIso: string): number => {
  const monthDate = new Date(monthIso)
  const daysInMonth = getDate(endOfMonth(monthDate))
  let sundays = 0
  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(monthDate.getFullYear(), monthDate.getMonth(), day)
    if (getDay(date) === 0) sundays++
  }
  return sundays
}

export const generateMonthOptions = () => {
  const currentMonth = getMonth(new Date())
  const currentYear = new Date().getFullYear()

  return Array.from({ length: MAX_MONTHS_AHEAD_FOR_GOALS + 1 }, (_, index) => {
    const date = new Date(currentYear, currentMonth + index, 1)
    date.setUTCHours(15, 0, 0, 0)

    return {
      value: date.toISOString(),
      label: format(date, 'MMMM - yyyy', { locale: ptBR })
    }
  })
}

export const buildGoalSections = (
  month: string,
  periodType: 'single' | 'multiple'
): ISection[] => {
  if (periodType === 'single') {
    const start = set(startOfMonth(new Date(month)), timeConfiguration)
    const end = set(endOfMonth(new Date(month)), timeConfiguration)
    return [{ start: start.toISOString(), end: end.toISOString() }]
  }

  const lastDayOfCurrentMonthGoal = getDate(endOfMonth(new Date(month)))
  const startDates = [1, 9, 16, 23]
  const endDates = [8, 15, 22, lastDayOfCurrentMonthGoal]

  return startDates.map((date, index) => {
    const start = set(new Date(month), { ...timeConfiguration, date })
    const end = set(new Date(month), { ...timeConfiguration, date: endDates[index] })
    return { start: start.toISOString(), end: end.toISOString() }
  })
}

export const normalizeSectionsToMonth = (
  sections: ISection[] | undefined,
  month: string,
  periodType: 'single' | 'multiple'
): ISection[] => {
  if (!sections || sections.length === 0) return buildGoalSections(month, periodType)

  return sections.map((section, index) => {
    const isLastSection = index === sections.length - 1
    const monthDate = new Date(month)
    const start = set(new Date(section.start), {
      ...timeConfiguration,
      year: getYear(monthDate),
      month: monthDate.getMonth()
    })
    const end = set(new Date(section.end || section.start), {
      ...timeConfiguration,
      ...(isLastSection ? { date: getDate(endOfMonth(monthDate)) } : {}),
      year: getYear(monthDate),
      month: monthDate.getMonth()
    })

    return { start: start.toISOString(), end: end.toISOString() }
  })
}
